import React from "react";
import { RenderNumber } from "Utils/renderField/renderReadField";
import Badge from "Utils/Badge/Badge";
import { formatPalletLabel } from "../../../../ProduccionV2/helpers/formatPallet";

export const DetallesTable = ({ trasladoDetalle }) => {
    const detalles =
        trasladoDetalle && trasladoDetalle.detalles
            ? trasladoDetalle.detalles
            : [];

    if (detalles.length === 0) return null;

    return (
        <React.Fragment>
            <h6 className="text-black">Pacas de pallets trasladadas</h6>
            <div className="new-table-wrapper boleta-control-calidad__table-wrapper mt-2">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>PALLET</th>
                            <th>PRODUCTO</th>
                            <th>ORIGEN</th>
                            <th>TARJETA</th>
                            <th>PACAS TRASLADADAS</th>
                            <th>PACAS FINALES ORIGEN</th>
                            <th>PACAS FINALES DESTINO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center text-nowrap">
                                        {formatPalletLabel(
                                            item.numero_pallet,
                                            item.identificador_fisico,
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap boleta-control-calidad__table-ellipsis-cell">
                                        {item.producto || "N/A"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.es_conforme_bodega_origen
                                            ? "Conforme"
                                            : "No conforme"}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.tarjeta_salida ? (
                                            <Badge
                                                text={`${
                                                    item.es_conforme_bodega_origen
                                                        ? "Roja"
                                                        : "Amarilla"
                                                } - ${item.tarjeta_salida}`}
                                                variant={
                                                    item.es_conforme_bodega_origen
                                                        ? "danger"
                                                        : "warning"
                                                }
                                            />
                                        ) : (
                                            "N/A"
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={item.pacas_trasladadas}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={item.pacas_finales_origen}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={item.pacas_finales_destino}
                                            decimalScale={0}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
